import { render, staticRenderFns } from "./SectionAdvantages.vue?vue&type=template&id=20c3d462&scoped=true&"
import script from "./SectionAdvantages.vue?vue&type=script&lang=js&"
export * from "./SectionAdvantages.vue?vue&type=script&lang=js&"
import style0 from "./SectionAdvantages.vue?vue&type=style&index=0&id=20c3d462&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c3d462",
  null
  
)

export default component.exports